module.exports = __webpack_public_path__ + "f6c073692b319b79f6c1c226c52250e7.pdf";